const STAFF_EVALUATION_SECTION = "staff_evaluation"
const DEPENDENT_KEYS = { overall_rating: true, scoring: true }

const stripOverallRatingDependentWhenNotMeeting = (sections, entityType) => {
  if (entityType === "meeting") return sections
  const staffEval = sections[STAFF_EVALUATION_SECTION]
  if (!staffEval?.length) return sections
  return {
    ...sections,
    [STAFF_EVALUATION_SECTION]: staffEval.map(field => {
      if (!DEPENDENT_KEYS[field?.key]) return field
      const { dependent, ...rest } = field
      return rest
    }),
  }
}

const reviewQestionsTransformer = (response, args) => {
  const entityType = response?.data?.entityType || args?.entityType
  const rawSections = response?.data?.sections
  const sections = stripOverallRatingDependentWhenNotMeeting(rawSections, entityType) // need to be updated from BE
  const callNextProposedTask = Object.values(sections ?? {})
    .flat()
    .some(f => f?.key === "next_proposed_task")
  return { sections, callNextProposedTask }
}

export default reviewQestionsTransformer
